import 'flickity/dist/flickity.pkgd.js';
import Flickity from 'flickity';
import 'viewerjs/dist/viewer.min.js';
import 'jquery-viewer/dist/jquery-viewer.min.js';
import flatpickr from 'flatpickr';

import { cookieConsent } from './scripts/cookie/cookieConsent';
import { deleteCookie } from './scripts/cookie/deleteCookie';
import { fullWidthVideoPlayerFile } from './scripts/video/fullWidthVideoPlayerFile';
import { videoPopupPlayerFile } from './scripts/video/videoPopupPlayerFile';
import { delayHomeBannerVideoFile } from './scripts/video/delayHomeBannerVideoFile';
import { headerScripts } from './scripts/header/headerScripts';
import { stickyMenu } from './scripts/header/stickyMenu';
import { loadMore } from './scripts/load-more/loadMore';
import { formScripts } from './scripts/form/formScripts';
import { cardSectionGridSlider } from './scripts/card/cardSectionGridSlider';
import { cardSectionSlider } from './scripts/card/cardSectionSlider';
import { logoSlider } from './scripts/logo/logoSlider';
import { logoSectionGridSlider } from './scripts/logo/logoSectionGridSlider';
import { gallerySectionSlider } from './scripts/gallery/gallerySectionSlider';
import { jqueryViewer } from './scripts/gallery/jqueryViewer';
import { editorContentAdditions } from './scripts/misc/editorContentAdditions';
import { testimonialSlider } from './scripts/testimonial/testimonialSlider';
import { photowalksSlider } from './scripts/photowalks/photowalksSlider';
import { testimonialGridSlider } from './scripts/testimonial/testimonialGridSlider';
import { featuredToursSlider } from './scripts/featured-tours/featuredTours';


// Flickity.prototype._createResizeClass = function() {
//   this.element.classList.add('flickity-resize');
// };

// Flickity.createMethods.push('_createResizeClass');

// var resize = Flickity.prototype.resize;
// Flickity.prototype.resize = function() {
//   this.element.classList.remove('flickity-resize');
//   resize.call( this );
//   this.element.classList.add('flickity-resize');
// };

export default {
  init() {
    // JavaScript to be fired on all pages
    Flickity.defaults.dragThreshold = 3;
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // Check the possibility to initialize of sliders inline in the php to reduce the amount of scripts files
    logoSlider();
    cookieConsent();
    deleteCookie('PREF');
    headerScripts();
    stickyMenu();
    logoSectionGridSlider();
    formScripts();
    cardSectionGridSlider();
    cardSectionSlider();
    gallerySectionSlider();
    jqueryViewer('.gallery-images-viewer-v2');
    jqueryViewer('.gallery-images-viewer-v1');
    fullWidthVideoPlayerFile();
    videoPopupPlayerFile();
    delayHomeBannerVideoFile();
    editorContentAdditions();
    loadMore();
    testimonialGridSlider();
    testimonialSlider();
    photowalksSlider();
    featuredToursSlider();
    footerTicker();
    bookingFormScripts();
    datepickerScripts();
    // Check the possibility to initialize of sliders inline in the php to reduce the amount of scripts files

    setTimeout(function(){
      updateSliderButtons()
    }, 500);

    //This script to be moved to a separate file as per other scripts
    $(document).on('click', '.slider-button-left', function () {
      var $section = $(this).closest('.section-inner-wrp');
      $section.find('.flickity-button.previous').click();
    });

    $(document).on('click', '.slider-button-right', function () {
      var $section = $(this).closest('.section-inner-wrp');
      $section.find('.flickity-button.next').click();
    });
    //This script to be moved to a separate file as per other scripts
  },
};

$(window).bind('load resize', function() {
  setTimeout(function(){
    cardSectionGridSlider();
  }, 500);
});

$(window).on('resize', function () {
  $('.cards-section.slider .cards-wrp, .cards-section.grid .cards-wrp'
  ).flickity('resize');

  setTimeout(function(){
    updateSliderButtons()
  }, 500);
  // flickity resize to work when specific amount of pixels are resized eg: now at 10px
  const previousWidth = $(window).data('previousWidth') || $(window).width();
  const currentWidth = $(window).width();
  const resizeDelta = Math.abs(currentWidth - previousWidth);

  if (resizeDelta > 10) {
    $('.flickity-viewport').css('height', '400px');
  }

  $(window).data('previousWidth', currentWidth);
  // flickity resize to work when specific amount of pixels are resized eg: now at 10px

  // set header height to sticky overlay
  $('.sticky-overlay').outerHeight($('.header').outerHeight());
  $('.main > section:first-child:not(".news-listing-section, .home-banner-section, .header-variation-active, .fcp-section"), .main > section.page-banner-section .banner-heading-wrp').css('padding-top', $('.header').outerHeight());

  photowalksSlider();
  $('.home-photography-walks-section.slider .testimonials-row').flickity('resize');
  testimonialSlider();
  $('.testimonials-section.slider.base-testimonials .testimonials-row').flickity('resize');
  featuredToursSlider();
});

$(window).on('load', function () {
  $('.carousel .carousel-resize').flickity('resize');

  cardSectionGridSlider();
});

//This script to be moved to a separate file as per other scripts
function updateSliderButtons() {
  $('.carousel').each(function () {
    const $section = $(this);
    const hasFlickity = $section.find('.flickity-button').length > 0;
    const hasCustomButtons = $section.find('.slider-buttons-wrp').length > 0;

    //Add custom buttons if Flickity buttons are present and custom buttons are missing
    if (hasFlickity && !hasCustomButtons) {
      const $wrapper = $('<div>', { class: 'slider-buttons-wrp' });

      $.each(['left', 'right'], function (index, dir) {
        $('<span>', {
          class: 'slider-button slider-button-' + dir,
        }).appendTo($wrapper);
      });

      $section.find('.slider-buttons-wrp-outer').append($wrapper);
    }

    //Remove custom buttons if Flickity buttons are missing
    if (!hasFlickity && hasCustomButtons) {
      $section.find('.slider-buttons-wrp').remove();
    }
  });
}
// This script to be moved to a separate file as per other scripts

// footer ticker
function footerTicker() {
  if ($('.footer-ticker-wrp').length) {
    // Play with this value to change the speed
    let tickerSpeed = 1;

    let flickity = null;
    let isPaused = false;
    const slideshowEl = document.querySelector('.footer-ticker-wrp');

    const update = () => {
      if (isPaused) return;
      if (flickity.slides) {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
        flickity.selectedIndex = flickity.dragEndRestingSelect();
        flickity.updateSelectedSlide();
        flickity.settle(flickity.x);
      }
      window.requestAnimationFrame(update);
    };

    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };

    flickity = new Flickity(slideshowEl, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25,
      initialIndex: 2,
    });

    flickity.x = 0;

    slideshowEl.addEventListener('mouseenter', pause, false);
    slideshowEl.addEventListener('focusin', pause, false);
    slideshowEl.addEventListener('mouseleave', play, false);
    slideshowEl.addEventListener('focusout', play, false);

    flickity.on('dragStart', () => {
      isPaused = true;
    });

    update();
  }
}
// footer ticker

function bookingFormScripts() {

  const $dropdown   = $('.participants-dropdown');
  const $priceItems = $('.tour-price-wrp > .tour-price-item');

  // 🚫 Exit early if required elements don’t exist
  if (!$dropdown.length || !$priceItems.length) {
    return;
  }

  // Safety: hide everything first
  $priceItems.hide();

  // ✅ SHOW FIRST GROUP ON LOAD
  const firstParticipant = $priceItems.first().data('participant');

  $priceItems.filter(function () {
    return $(this).data('participant') === firstParticipant;
  }).show();

  // 🔁 CHANGE HANDLER
  $dropdown.on('change', function () {
    const selectedValue = $(this).val();

    if (!selectedValue) return; // keep current visible if placeholder selected

    $priceItems.hide();

    $priceItems.filter(function () {
      return $(this).data('participant') === selectedValue;
    }).show();
  });
}

// Used flatpickr package for this datepicker
function datepickerScripts() {
  const $dateFields = $('.js-tour-dates');

  if (!$dateFields.length) return;

  $dateFields.each(function () {
    flatpickr(this, {
      mode: 'range',
      dateFormat: 'Y-m-d',
      minDate: 'today',
      allowInput: false,
    });
  });
}
// Used flatpickr package for this datepicker
